import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import "./Services.css";
import Car1 from "../../assets/img/diensten/autoschades.jpeg";
import Car3 from "../../assets/img/20210528_101302.jpg";
import Car4 from "../../assets/img/20190121_172412.jpg";
import Car5 from "../../assets/img/20210526_200124.jpg";
import Car6 from "../../assets/img/diensten/bestelwagens.png";

const LUXURY = [0.16, 1, 0.3, 1];

const services = [
  {
    id: 1,
    title: "Herstellen autoschades",
    description:
      "Professionele herstelling van alle soorten autoschades.",
    image: Car1,
    alt: "Auto schade herstelling",
    serial: "01 — AUTOSCHADE",
  },
  {
    id: 2,
    title: "Spuiten van brommers, poorten en afvoerbuizen",
    description:
      "Vakkundige spuitwerk voor diverse objecten buiten auto's, zoals brommers en metalen constructies.",
    image: Car3,
    alt: "Spuitwerk diensten",
    serial: "02 — SPUITWERK",
  },
  {
    id: 3,
    title: "Spuiten van wagens",
    description:
      "Complete lakbehandelingen en spuitwerk voor personen- en bedrijfswagens.",
    image: Car4,
    alt: "Auto spuitwerk",
    serial: "03 — LAK",
  },
  {
    id: 4,
    title: "Herstellen van racewagens",
    description:
      "Gespecialiseerde reparaties en onderhoud voor racewagens en sportvoertuigen.",
    image: Car5,
    alt: "Racewagen reparatie",
    serial: "04 — SPECIALS",
  },
  {
    id: 5,
    title: "Herstellen Lichte vracht",
    image: Car6,
    alt: "Lichte vracht reparatie",
    serial: "05 — BESTELWAGEN",
  }
];

export default function Services() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-8%" });

  return (
    <section className="services-section" id="services" ref={ref}>
      <div className="container services-container">
        {/* ── Section header ── */}
        <motion.div
          className="services-header"
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
          transition={{ duration: 0.8, ease: LUXURY }}
        >
          <span className="section-badge">Diensten</span>
          <h2 className="services-heading">Onze specialiteiten</h2>
          <p className="services-intro">
            Wij bieden een breed scala aan professionele carrosseriediensten met
            jarenlange ervaring en de nieuwste technieken.
          </p>
        </motion.div>

        {/* ── Bento grid ── */}
        <div className="services-grid">
          {services.map((service, i) => (
            <motion.div
              key={service.id}
              className={`service-card service-card--${i + 1}`}
              initial={{ opacity: 0, y: 36 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{
                duration: 0.75,
                delay: 0.15 + i * 0.1,
                ease: LUXURY,
              }}
            >
              {/* Image — shutter reveal + cinematic hover zoom */}
              <motion.div
                className="service-image-container"
                initial={{ clipPath: "inset(0 0 100% 0)" }}
                animate={isInView ? { clipPath: "inset(0 0 0% 0)" } : {}}
                transition={{
                  duration: 0.9,
                  delay: 0.2 + i * 0.1,
                  ease: LUXURY,
                }}
              >
                <motion.img
                  src={service.image}
                  alt={service.alt}
                  className="service-image"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 1.2, ease: LUXURY }}
                />
                <div className="service-image-overlay" />
              </motion.div>

              {/* Content */}
              <div className="service-content">
                <span className="service-serial">{service.serial}</span>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>

                <button
                  className="service-link"
                  onClick={() => {
                    document
                      .getElementById("contact")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                  aria-label={`Meer informatie over ${service.title}`}
                >
                  <span className="service-link-text">Vraag offerte</span>
                  <span className="service-link-underline" />
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
